import {
  CigaretteOff, PartyPopper, Footprints, Moon, VolumeX, PawPrint, Dog,
  Utensils, Wine, Recycle, Users, Baby, Flame, Waves, Bath, Sparkles,
  Key, Snowflake, Zap, Trash2, Ban, CameraOff, Leaf, Wifi, Heart, ShieldCheck,
} from "lucide-react";

// Catalogo icone regole: id, etichetta IT, colore, componente icona.
export const RULE_ICONS = [
  { id: "no_smoking", label: "No fumo", color: "#EF4444", Icon: CigaretteOff },
  { id: "no_parties", label: "No feste", color: "#EC4899", Icon: PartyPopper },
  { id: "no_shoes", label: "No scarpe in casa", color: "#92400E", Icon: Footprints },
  { id: "quiet", label: "Silenzio / riposo", color: "#7C3AED", Icon: Moon },
  { id: "no_noise", label: "No rumori", color: "#6366F1", Icon: VolumeX },
  { id: "pets_ok", label: "Animali ammessi", color: "#F59E0B", Icon: PawPrint },
  { id: "no_pets", label: "No animali", color: "#B91C1C", Icon: Dog },
  { id: "no_food", label: "No cibo in camera", color: "#EA580C", Icon: Utensils },
  { id: "no_alcohol", label: "No alcol", color: "#E11D48", Icon: Wine },
  { id: "recycle", label: "Raccolta differenziata", color: "#16A34A", Icon: Recycle },
  { id: "no_guests", label: "No ospiti esterni", color: "#2563EB", Icon: Users },
  { id: "kids_ok", label: "Bimbi benvenuti", color: "#DB2777", Icon: Baby },
  { id: "no_candles", label: "No fiamme / candele", color: "#F97316", Icon: Flame },
  { id: "pool", label: "Regole piscina", color: "#0891B2", Icon: Waves },
  { id: "bathroom", label: "Bagno", color: "#06B6D4", Icon: Bath },
  { id: "cleaning", label: "Pulizia", color: "#8B5CF6", Icon: Sparkles },
  { id: "keys", label: "Chiavi", color: "#D97706", Icon: Key },
  { id: "ac", label: "Aria condizionata", color: "#0EA5E9", Icon: Snowflake },
  { id: "energy", label: "Risparmio energia", color: "#CA8A04", Icon: Zap },
  { id: "trash", label: "Rifiuti", color: "#64748B", Icon: Trash2 },
  { id: "no_photos", label: "No foto / video", color: "#475569", Icon: CameraOff },
  { id: "eco", label: "Eco / ambiente", color: "#22C55E", Icon: Leaf },
  { id: "wifi", label: "Wi-Fi", color: "#3B82F6", Icon: Wifi },
  { id: "care", label: "Con cura", color: "#F43F5E", Icon: Heart },
  { id: "tidy", label: "Lascia in ordine", color: "#10B981", Icon: ShieldCheck },
  { id: "general", label: "Divieto generico", color: "#EF4444", Icon: Ban },
];

export const getRuleIcon = (id) => RULE_ICONS.find((r) => r.id === id) || null;
